import { ReactElement, ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type GroupSessionsPanelActionBarProps = {
   children: ReactNode;
};

export const GroupSessionsPanelActionBar = (props: GroupSessionsPanelActionBarProps): ReactElement => {
   return (
      <ActionBar testId={'groupSessions'} id={'group-sessions-action-bar'}>
         {props.children}
      </ActionBar>
   );
};
